export const COMPANY_NAME = "Inversiones Lactium RR26, C.A";
export const COMPANY_SHORT_NAME = "Lactium";
export const COMPANY_RIF = "J-508701275";
export const COMPANY_TITLE = COMPANY_NAME;
export const COMPANY_LOGO = "/logo.png";
export const COMPANY_SLOGAN = "Desde el campo a tu mesa";

export const companyPageTitle = (page) =>
  page ? `${page} | ${COMPANY_NAME}` : COMPANY_NAME;
